module.exports = __webpack_public_path__ + "static/img/花瓶13.a103c09.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/papercutLamp/imgs/花瓶13.png
// module id = 0n6y
// module chunks = 2